import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const exportExcel = (datas, fileName, noDataMessage = false) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(datas);

  // Si no hay datos, agregar un mensaje en la hoja de Excel
  if (noDataMessage && datas.length) {
    const headers = Object.keys(datas[0]);
    const totalColumns = headers.length;

    // Escribimos el mensaje en A2
    ws["A2"] = { t: "s", v: "NO HAY RESULTADOS" };
    ws["A2"].s = {
      font: { bold: true, color: { rgb: "FF0000" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    // Merge desde A2 hasta última columna
    ws["!merges"] = [
      {
        s: { r: 1, c: 0 },
        e: { r: 1, c: totalColumns - 1 },
      },
    ];
  };

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

export const exportExcel2Sheets = (datas, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(datas[0]);
  const ws2 = XLSX.utils.json_to_sheet(datas[1]);
  const wb = {
    Sheets: { data: ws, data2: ws2 },
    SheetNames: ["data", "data2"],
  };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

export function exportToExcel(array, filename) {
  const worksheet = XLSX.utils.json_to_sheet(array);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, `${filename}.xlsx`);
}

export function exportPDF(datas, fileName) {
  const pdfDoc = pdfMake.createPdf({
    content: [
      { text: fileName, style: "header" },
      {
        table: {
          headerRows: 1,
          body: datas,
        },
      },
    ],
    styles: {
      header: { fontSize: 16, bold: true, marginBottom: 10 },
    },
  });

  // Descargamos el archivo PDF generado
  pdfDoc.download(fileName + ".pdf");
}
